import React from 'react';

import { Button } from '@headlessui/react';

import cn from '~/utils/cn';

export interface AuthenticationButtonProps {
  onClick?: () => void;
  icon?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  disabled?: boolean;
}

const AuthenticationButton: React.FC<AuthenticationButtonProps> = ({
  onClick,
  icon,
  children,
  className = '',
  disabled = false,
}) => {
  return (
    <Button
      as="button"
      onClick={onClick}
      disabled={disabled}
      className={cn(
        'border-grey-600 box-content flex w-full items-center justify-center rounded-full border bg-white py-8' +
          ' text-grey-600 cursor-pointer transition duration-150 ease-in-out hover:bg-slate-300',
        disabled ? 'cursor-not-allowed opacity-50' : '',
        className
      )}
    >
      {icon ? <span className="pr-8">{icon}</span> : null}
      <>{children}</>
    </Button>
  );
};

export default AuthenticationButton;
